"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("./index99.js");var r=t.toLength,n=function(e){return r(e.length)};exports.lengthOfArrayLike=n;
